<template>
<a-trigger trigger="hover" position="lt" :popup-translate="[-18, 0]" ref="triggerRef" class="fob_flag xmxmxmxmx">
      <slot></slot>
      <template #content>
        <div class="fileOperateBtn_container">
          <div class="fob_item" @click="() => selectionAction(0)">
            <svg-icon :name="'header-file_visit'"></svg-icon>
            <span>{{$t("访问记录")}}</span>
          </div>
          <div style="height: 4px;"></div>
          <div class="fob_item" @click="() => selectionAction(1)">
            <svg-icon :name="'header-file_operate'"></svg-icon>
            <span>{{$t("操作记录")}}</span>
          </div>
        </div>
      </template>
    </a-trigger>
</template>

<script lang="ts">
export default {
    name: "FileOperateBtn",
    data() {
        return {

        };
    },
    emits: {
      onselectionchange: (value: number) => true,
    },
    watch: {},
    computed: {
    },
    methods: {
      selectionAction(value: number) {
        document.querySelectorAll(".xmxmxmxmx")?.forEach((item) => item.remove());
        document.querySelectorAll(".header-more-popover-container")?.forEach((item) => item.remove());
        this.$emit("onselectionchange", value);
      },
    },
};
</script>

<style lang="scss" scoped>
.fileOperateBtn_container {
  box-sizing: border-box;
  padding: 4px;
  background: #FFFFFF;
  border: 1px solid #E6E8EC;
  box-shadow: 0 8px 12px 0 #1213171a;
  border-radius: 8px;
  .fob_item {
    width: 138px;
    height: 32px;
    display: flex;
    align-items: center;
    &:hover {
      background: #F4F6F9;
      border-radius: 8px;
    }

    font-weight: 400;
    font-size: 14px;
    color: #222329;
    svg {
      width: 16px;
      height: 16px;
      margin-left: 8px;
      margin-right: 8px;
    }
  }
}
</style>
